<template>
  <div style="display: flex;">
    <rack-group-stock-report
      v-for="report in rgStockReports"
      :key="report.id"
      :rg-stock-report="report"
    />
  </div>
</template>

<script>
import RackGroupStockReport from './RackGroupStockReport.vue'

export default {
  components: {
    RackGroupStockReport,
  },
  props: {
    rgStockReports: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
